import PropTypes from 'prop-types';
import React from 'react';
import styles from './styles.module.scss';
import { Row, Col} from 'react-bootstrap';
import PardotConfigurationPage from './PardotConfigurationPage';
import DeactivateIntegrationContainer from 'src/legacy/components/DeactivateIntegration/index';
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import { shouldFetchIntegrations } from 'src/legacy/services/utils';
import { localizedStrings } from 'src/localization/index.jsx';
import DOMPurify from 'dompurify';
import { PardotSideBar } from './PardotSideBar';
import { PardotOnboardingView } from './PardotOnboardingView';
import _ from 'lodash';
import buildUrl from "build-url-ts";

const apiUrl = `${process.env.REACT_APP_API_URL}`;
class PardotView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      deleteConfirmation: false,
      showIntergrationOnboarding: false,
      isScrollDisabled: false,
      selectedTab: null,
      integrationCreatedBy: _.get(this.props.integration, "createdBy") || '',
    };

    this.handleAuthenticate = this.handleAuthenticate.bind(this);
    this.handleAuthenticateEvent = this.handleAuthenticateEvent.bind(this);
    this._handleDeactivateClicked = this._handleDeactivateClicked.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.disableScroll = this.disableScroll.bind(this);
    this.showIntergrationOnboarding = this.showIntergrationOnboarding.bind(this);
    this.canEdit = this.canEdit.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedPardot = localizedStrings.components.integrations.pardot;
  }

  componentDidMount() {

    if(shouldFetchIntegrations(this.props.integrations)) {
      this.props.fetchIntegrations();
    }
    const integration = localizedStrings.constants.integrationsOnboarding.integrations.pardot;
    const sections = integration.sections;
    this.setState({
      selectedTab: sections[0].id,
      showIntergrationOnboarding: !_.get(this.props, "integration", true),

    })
  }

  _handleDeactivateClicked(){
    this.setState({
      deleteConfirmation: true
    })
  }

  showIntergrationOnboarding(){
    this.setState({
      showIntergrationOnboarding: !this.state.showIntergrationOnboarding
    })
  }

  disableScroll(value){
    this.setState({
      isScrollDisabled: value
    })
  }

  handleScroll = (e) => {

    if(this.state.isScrollDisabled){
      return;
    }

    const integration = localizedStrings.constants.integrationsOnboarding.integrations.pardot;
    const sections = integration.sections;

    if(sections) { 
      const buffer = 25;
      let selectedTabIndex = 0;

      for (let i = 0; i < sections.length; i++) {

      const sectionId = sections[i].id;
      const element = document.getElementById(sectionId);

      if (element) {
        const { top } = element.getBoundingClientRect();
        const position = top;

        if ( e.target.scrollTop >= position - buffer) {
          selectedTabIndex = i;
        } 
      }
    }
    
    this.setState({
      selectedTab: sections[selectedTabIndex].id,
    })
  }};

  canEdit() {
    if (_.get(this.props, "user.admin")) {
      return true;
    } else if (_.get(this.state, "integrationCreatedBy")) {
      return (_.get(this.state, "integrationCreatedBy.id") === (_.get(this.props, "user.id")));
    }
    return false;
  }


  render(){

    if (this.props.loading) {
      return this._renderLoadingMessage();
    }

    var isAuthenticated = false; 

    if(this.props.integration && this.props.integration.state.code === "ok" && !this.props.error) {
        isAuthenticated = true;
    }

    var isTokenExpired = _.get(this.props, 'integration.state.code') === "auth_error";

    return (
      <div className={styles.content}>
        <Row className={styles.row}>
          <Col md={3} className={styles.left}>
          <PardotSideBar
              integration={this.props.integration}
              handleAuthenticate={this.handleAuthenticate}
              showIntergrationOnboarding={this.showIntergrationOnboarding}
              _handleDeactivateClicked={this._handleDeactivateClicked}
              deactivating={this.props.deactivating}
              isAuthenticated={isAuthenticated}
              authenticating={this.props.authenticating}
              isTokenExpired={isTokenExpired}
              canEdit={this.canEdit}
              navigate={this.props.navigate}
              isShowIntegrationOnboarding={this.state.showIntergrationOnboarding}
              handleIntegrationsBackButton={this.props.handleIntegrationsBackButton}
            />
          </Col>
          <Col md={9} id="right" className={styles.right} onScroll={(e) => this.handleScroll(e)}>
          {this.props.integrationsLoading && (
          <p className={styles.integrationLoading}>{this.localizedCommons.loading.loading}...</p>)}
          {!this.props.integrationsLoading && (!_.get(this.props, "integration") || this.state.showIntergrationOnboarding) && (
           <PardotOnboardingView
             selectedTab={this.state.selectedTab}
             disableScroll={this.disableScroll}
             />
             )}

            {_.get(this.props, "integration") && !isAuthenticated && !this.state.showIntergrationOnboarding && isTokenExpired &&(
                <div className={styles.authMessage}>
                  <h2>{this.localizedPardot.expired.title}</h2>
                  <p>{this.localizedPardot.expired.sub_text}</p>
                </div>
              )}

            {!isAuthenticated && (!_.get(this.props, "integration")) && this.state.showIntergrationOnboarding && 
              <div className={styles.authorize}>
                <h3>{ this.localizedPardot.activate.title }</h3>
                <p dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.localizedPardot.activate.sub_text)}} />
                <button className={styles.authButton} onClick={this.handleAuthenticate} disabled={this.props.authenticating}>
                  {this.props.authenticating &&
                    `${this.localizedIntegrations.actions.authenticating}...`
                  }

                  {!this.props.authenticating &&
                     this.localizedIntegrations.actions.authenticate
                  }
                </button>
              </div>
            }
            {isAuthenticated && _.get(this.props, "integration") && !this.state.showIntergrationOnboarding  &&
              <PardotConfigurationPage store={this.context.store} integration= {this.props.integration} canEdit={this.canEdit}/>
            }  
          </Col>
        </Row>
        <DeactivateIntegrationContainer
          name = {this.localizedPardot.deactivate_slider.title}
          type="pardot"
          message= {this.localizedPardot.deactivate_slider.sub_text}
          show={this.state.deleteConfirmation}
          onCancel={()=> {
          this.setState({
            deleteConfirmation: false
           })
          }}
        />
      </div>
    );
  }

  _renderLoadingMessage() {
    return (
      <LoadingMessage
        className={styles.loadingMessage}
        message={`${this.localizedPardot.loading}...`}
        visible={this.props.loading}
      />
    )
  }

  handleAuthenticate(){
    //Calculate Position
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screen.left;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screen.top;
    
    var  width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
    var   height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;
    
    var w = 0.8 *width;
    var h = 0.8 * height;
    
    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;
      
    const url = buildUrl(apiUrl, {
      path: `/api/2.0/integrations/pardot/authorize`
    })

    var newWindow = window.open(url, `Authorize Pardot Account`, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (newWindow.focus) {
        newWindow.focus();
    }

    //Attaching message event listner
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

    // Listen to message from child window
    eventer(messageEvent, this.handleAuthenticateEvent, false);
    return false; 
  }

  handleAuthenticateEvent(e) {

    //Removing message event listner
    var detachEventMethod = window.removeEventListener ? 'removeEventListener' : 'detachEvent';
    var deEventer = window[detachEventMethod];
    var messageEvent = detachEventMethod == "detachEvent" ? "onmessage" : "message";

    if (e.data.type == 'PARDOT_AUTHORIZATION_SUCCESS') {
      var code = e.data.payload.code;
      var state = e.data.payload.state;
      var error = e.data.payload.error;
      this.props.trackAdoptionMetricsForPluginConnectedEvent('Pardot')
      if (!error) {
        this.props.authenticateAccount(code);
      }

      deEventer(messageEvent, this.handleAuthenticateEvent, false);
    }
  }

}

export default PardotView;